module.exports = __webpack_public_path__ + "img/Chris.d2f6cfd4.png";